import React, { useContext } from "react";
import { connect } from "react-redux";
import { TableContext } from "../index";
import { Checkbox } from "../view/Checkbox";
import { deepCopy } from "../utils";
import { useHistory } from "react-router-dom";
import { MoreVertical, Eye } from 'lucide-react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

//const moment = require('moment');

const Severity = {
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low'
}
const getViolationType = (data) => data.violationType || (data.recordType === "DEVICE" ? "Syslog Violation" : "Rule Violation");

function RecentViolationsTableRow({ data, index, hiddenHeaders = [], onViewDeviceViolation }) {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    // Menu state
    const [anchorEl, setAnchorEl] = React.useState(null);
    const menuOpen = Boolean(anchorEl);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const getCircleType = () => {

        if (!data.severity) {
            return '';
        }

        switch (data.severity.toLowerCase()) {
            case Severity.HIGH:
                return "severity-high";
            case Severity.MEDIUM:
                return "severity-medium";
            case Severity.LOW:
                return "severity-low";
            default:
                return null;
        }
    }

    const onCheckboxChange = () => {
        if (data.recordType === "DEVICE") return;
        let selectedRows = deepCopy(config.selected);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id)
        }
        setConfig({ ...config, selected: selectedRows })

    }

    const onClick = () => {
        handleMenuClose();
        if (data.recordType === "DEVICE") {
            onViewDeviceViolation(data);
            return;
        }
        history.push('/add-rules/' + data.rulePk);
    };

    const getDateTimeFormat = (bigIntTime) => {
        if (!bigIntTime) {
            return ''
        }
        let datetime = Number(bigIntTime)
        let datetimeformat = 'N/A';
        const dateObject = new Date(datetime)
        datetimeformat = dateObject.toLocaleString()
        return datetimeformat;

    }

    return (
        <tr key={index}>
            <td>
                {data.recordType === "DEVICE"
                    ? null
                    : <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />}
            </td>
            {hiddenHeaders.includes("DEVICE") ? null : <td>{data.device}</td>}
            {hiddenHeaders.includes("RULE NAME") ? null : <td><strong>{data.rule}</strong></td>}
            {hiddenHeaders.includes("DESCRIPTION") ? null : <td>{data.details}</td>}
            {hiddenHeaders.includes("TYPE") ? null : <td>{getViolationType(data)}</td>}
            {/* <td>{data.expectedOutput}</td> */}
            {hiddenHeaders.includes("VIOLATION DATE") ? null : <td>{getDateTimeFormat(data.startTime)}</td>}
            {/* <td>{data.user}</td> */}
            {hiddenHeaders.includes("SEVERITY") ? null : (
                <td>
                    <span className={`oct_severity-badge-v2 ${getCircleType()}`}>
                        {data.severity?.toUpperCase()}
                    </span>
                </td>
            )}
            {config.showRemediated && !hiddenHeaders.includes("REMEDIATED DATE") &&
                <td>
                    {getDateTimeFormat(data.remediatedDate)}
                </td>
            }
            <td className="oct_table-actions-cell-v2">
                <button className="oct_dropdown-trigger-v2" onClick={handleMenuClick}>
                    <MoreVertical className="oct_icon" />
                </button>
                <Menu
                    anchorEl={anchorEl}
                    open={menuOpen}
                    onClose={handleMenuClose}
                    className="oct_menu-v2"
                >
                    <MenuItem onClick={onClick} className="oct_menu-item-v2">
                        <Eye size={16} className="me-2" />
                        Violation Details
                    </MenuItem>
                </Menu>
            </td>
        </tr>
    )

}

export default connect()(RecentViolationsTableRow);
